import { ContextConsumer } from '@lit/context';
import { LitElement, ReactiveController, ReactiveControllerHost } from 'lit';
import { dirtyContext } from '../context/dirty-form';
import { createDirtyFormGuardEvent } from '../context/dirty-form-guard';

export class DirtyFormController implements ReactiveController {
  host: ReactiveControllerHost & LitElement;

  private _dirtyContext: ContextConsumer<
    {
      __context__: boolean;
    },
    ReactiveControllerHost & LitElement
  >;

  constructor(host: LitElement) {
    (this.host = host).addController(this);

    this._dirtyContext = new ContextConsumer(this.host, { context: dirtyContext, subscribe: true });
  }

  private onClick = (event: Event) => this.handleClick(event);

  hostConnected() {
    this.host.shadowRoot?.addEventListener('click', this.onClick);
  }

  hostDisconnected() {
    this.host.shadowRoot?.removeEventListener('click', this.onClick);
  }

  private handleClick(event: Event) {
    const isOrHasAnchor = (el: HTMLElement): HTMLAnchorElement | null => {
      if (el instanceof HTMLAnchorElement) {
        return el;
      }
      return el.parentElement != undefined ? isOrHasAnchor(el.parentElement) : null;
    };
    const targetEL = isOrHasAnchor(event.target as HTMLElement);
    if (targetEL != null && this._dirtyContext.value) {
      this.host.dispatchEvent(createDirtyFormGuardEvent(targetEL.href));

      event.preventDefault();
      event.stopPropagation();

      return false;
    }

    return true;
  }
}
